/**
 * Content tag bundle definitions
 * @module content/bundles
 */

import { Map } from 'immutable'
import { CONTENT_TYPE_PERSON, CONTENT_TYPE_TAG } from './content-types'

export const BUNDLE_ADMIN_CATEGORY = 'admin_category'
export const BUNDLE_CATEGORY = 'category'
export const BUNDLE_CENTERS = 'centers'
export const BUNDLE_MARKETING_CENTERS = 'marketing-centers'
export const BUNDLE_RAINBOW_CATEGORY = 'rainbow_category'
export const BUNDLE_CONTENT_ORIGIN = 'content_origin'
export const BUNDLE_FILTER_OPTIONS = 'filter_options'
export const BUNDLE_FILTER_TYPES = 'filter_types'
export const BUNDLE_GENRES = 'genres'
export const BUNDLE_ONBOARDING_CHOICES = 'onboarding_choices'
export const BUNDLE_PARENTAL_RATING = 'parental_rating'
export const BUNDLE_PEOPLE = 'people'
export const BUNDLE_RECIPE_DIET = 'recipe_diet'
export const BUNDLE_RECIPE_TYPE = 'recipe_type'
export const BUNDLE_SITE_SEGMENT = 'site_segment'

export const BUNDLE_LABELS = Map({
  [BUNDLE_ADMIN_CATEGORY]: 'Admin Category',
  [BUNDLE_CATEGORY]: 'Category',
  [BUNDLE_CENTERS]: 'Centers',
  [BUNDLE_MARKETING_CENTERS]: 'Marketing Centers',
  [BUNDLE_RAINBOW_CATEGORY]: 'Rainbow Category',
  [BUNDLE_CONTENT_ORIGIN]: 'Content Orgin',
  [BUNDLE_FILTER_OPTIONS]: 'Filter Options',
  [BUNDLE_FILTER_TYPES]: 'Filter Types',
  [BUNDLE_GENRES]: 'Genres',
  [BUNDLE_ONBOARDING_CHOICES]: 'Onboarding Choices',
  [BUNDLE_PARENTAL_RATING]: 'Parental Rating',
  [BUNDLE_PEOPLE]: 'People',
  [BUNDLE_RECIPE_DIET]: 'Recipe Diet',
  [BUNDLE_RECIPE_TYPE]: 'Recipe Type',
  [BUNDLE_SITE_SEGMENT]: 'Site Segment',
})

export const BUNDLE_TYPES = Map({
  [BUNDLE_ADMIN_CATEGORY]: CONTENT_TYPE_TAG,
  [BUNDLE_CATEGORY]: CONTENT_TYPE_TAG,
  [BUNDLE_CENTERS]: CONTENT_TYPE_TAG,
  [BUNDLE_MARKETING_CENTERS]: CONTENT_TYPE_TAG,
  [BUNDLE_RAINBOW_CATEGORY]: CONTENT_TYPE_TAG,
  [BUNDLE_CONTENT_ORIGIN]: CONTENT_TYPE_TAG,
  [BUNDLE_FILTER_OPTIONS]: CONTENT_TYPE_TAG,
  [BUNDLE_FILTER_TYPES]: CONTENT_TYPE_TAG,
  [BUNDLE_GENRES]: CONTENT_TYPE_TAG,
  [BUNDLE_ONBOARDING_CHOICES]: CONTENT_TYPE_TAG,
  [BUNDLE_PARENTAL_RATING]: CONTENT_TYPE_TAG,
  [BUNDLE_PEOPLE]: CONTENT_TYPE_PERSON,
  [BUNDLE_RECIPE_DIET]: CONTENT_TYPE_TAG,
  [BUNDLE_RECIPE_TYPE]: CONTENT_TYPE_TAG,
  [BUNDLE_SITE_SEGMENT]: CONTENT_TYPE_TAG,
})

export const BUNDLE_VID_MAP = {
  12: BUNDLE_ADMIN_CATEGORY,
  1: BUNDLE_CATEGORY,
  61: BUNDLE_CENTERS,
  63: BUNDLE_MARKETING_CENTERS,
  13: BUNDLE_CONTENT_ORIGIN,
  36: BUNDLE_FILTER_OPTIONS,
  31: BUNDLE_FILTER_TYPES,
  7: BUNDLE_GENRES,
  66: BUNDLE_ONBOARDING_CHOICES,
  4: BUNDLE_PARENTAL_RATING,
  41: BUNDLE_PEOPLE,
  74: BUNDLE_RECIPE_DIET,
  73: BUNDLE_RECIPE_TYPE,
}
